module.exports = __webpack_public_path__ + "media/4x3/sc-e6584421.svg";